






































import Vue from 'vue';
import draggable from 'vuedraggable';
import { Column } from '@/main/utils/table';

export default Vue.extend({
	name: 'DmsTableSetting',
	components: {
		draggable,
	},
	props: {
		columns: { type: Array as () => Column[], default: () => [] },
		saveVisible: { type: Boolean },
	},
	data() {
		return {
			visiblePoper: false,
		};
	},
	computed: {
		viditelneLabel(): string {
			return this.Localize('ViditelneStlpce');
		},
		neViditelneLabel(): string {
			return this.Localize('NeViditelneStlpce');
		},
		visibleColumns: {
			get(): Column[] {
				return this.columns.filter((col) => col.isVisible);
			},
			set(columns: Column[]) {
				columns.forEach((col) => {
					col.isVisible = true;
				});
				this.$emit('update:columns', { visibles: true, columns });
			},
		},
		unVisibleColumns: {
			get(): Column[] {
				return this.columns.filter((col) => !col.isVisible);
			},
			set(columns: Column[]) {
				columns.forEach((col) => {
					col.isVisible = false;
				});
				this.$emit('update:columns', { visibles: false, columns });
			},
		},
		visible() {
			return { height: '400px' };
		},
		unVisible() {
			return { height: '400px' };
		},
	},
	methods: {
		save() {
			const columnsToSave = this.columnsToString(this.columns.filter((col) => col.isVisible));
			this.$emit('save-column-setting', columnsToSave.join(','));
			this.visiblePoper = false;
		},
		reset() {
			this.$emit('save-column-setting');
			this.visiblePoper = false;
		},
		columnsToString(columns: Column[], paretnColumn?: string): string[] {
			return columns.map((col) => (
				col.columns
					? this.columnsToString(col.columns!, col.columnName.concat('.')).join(',')
					: `${paretnColumn ?? ''}${col.columnName}`
			));
		},
	},
});
